import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";

import UserDataService from "../../services/User";

export const ProActivatationModal = ({ isOpen, onClose, id ,func}: any) => {
  const [module, setModule] = useState<any>("");

  const [period, setPeriod] = useState<any>(1);


  const handleSubmit = () => {
    if(module && period) {

        UserDataService.activatePro(id, period,module)
           .then((res: any) => {
            closeModal()
            func(true)
           })
           .catch((error: any) => {
             console.log(error);
           });
    }
  };
  const closeModal = () => {
    clearState();
    onClose();
  };
  const clearState = () => {
    setModule("");
    setPeriod("");
  };

  return (
    <Modal isOpen={isOpen} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Module and Period</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel htmlFor="module-select">Select Module</FormLabel>
            <Select
              name=""
              id="module-select"
              onChange={(e) => setModule(e.target.value)}
            >
              <option value="">Select Module</option>
              <option value="All">All</option>
              <option value="anxiety">Anxiety</option>
              <option value="depression">Depression</option>
              <option value="selfesteem">Self-esteem</option>
              <option value="procrastination">Procrastination</option>
              <option value="workstress">Work stress</option>
              <option value="trauma">Trauma</option>
              <option value="relationship">Relationship issues</option>
              <option value="greif">Grief and loss</option>
              <option value="mentalhealth">Mental Health</option>
              <option value="anger">Anger issues</option>
            </Select>
          </FormControl>
          <FormControl mt="25px">
            <FormLabel htmlFor="period-input">Enter Period (in months)</FormLabel>
            <Input
              type="number"
              id="period-input"
              min="1"
              onChange={(e:any) => setPeriod(e.target.value)}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Activate
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={closeModal}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
